

import {
	mdiBookshelf,
	mdiFrequentlyAskedQuestions,
} from "@mdi/js"
import { BackgroundDeepTurquoise } from "components/dashboard/dashboard-card"

export class SupportCardInfo
{
	public constructor(
		public background: any,
		public avatarIcon: string,
		public avatarColour: string
	)
	{
	}
}

export class SupportCardData
{
	public static readonly GUIDE = new SupportCardInfo(
		BackgroundDeepTurquoise,
		mdiBookshelf,
		"#27458d"
	)
	public static readonly FAQ = new SupportCardInfo(
		BackgroundDeepTurquoise,
		mdiFrequentlyAskedQuestions,
		"#18ABE9"
	)
}
